module.exports = __webpack_public_path__ + "img/Carte-platinum-blanche-ccs.7aa42101.png";